import styled, { css } from 'styled-components';
import { formatCurrency } from 'client/src/utils';

const Wrapper = styled.span`
  color: ${({ theme }) => theme.success};

  ${props =>
    props.isNegative &&
    css`
      color: ${({ theme }) => theme.error};
    `};

  ${props =>
    props.isMonochrome &&
    css`
      color: inherit;
    `};

  ${props =>
    props.isPrimary &&
    css`
      color: ${({ theme }) => theme.primary};
      font-weight: 600;
    `};
`;

const Amount = ({ amount, isMonochrome, isPrimary, shouldShowPlusSign }) => {
  return (
    <Wrapper isMonochrome={isMonochrome} isPrimary={isPrimary} isNegative={amount < 0}>
      {shouldShowPlusSign && amount > 0 && '+'}
      {formatCurrency(amount)}
    </Wrapper>
  );
};

Amount.defaultProps = {
  amount: 0,
  isMonochrome: false,
  shouldShowPlusSign: true,
};

export default Amount;
